import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Card, Col, Row, Table, Nav, Tab } from "react-bootstrap";
import axiosInstance from "../../../services/AxiosInstance";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination";
import useIsMobile from "../../../hooks/useIsMobile";

const ListUjian = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const isMobile = useIsMobile();
  const [query, setQuery] = useState("status=started");

  useEffect(() => {
    loadData();
  }, [currentPage, query]);

  const loadData = async () => {
    var res = await axiosInstance.get(
      `test-online/siswa/ujian?${query}&page=${currentPage}&per_page=${
        isMobile ? 5 : 10
      }`
    );
    setData(res.data.data);
    setTotalData(res.data.total);
  };

  const handlePaging = (page) => {
    console.log("page:", page);
    setCurrentPage(page);
    // loadData();
  };

  const handleMulaiUjian = (id) => {
    navigate(`/ujian/detail?id=${id}`);
  };

  const getStatusText = (status) => {
    switch (status) {
      case "created":
        return "Belum Mulai";

      case "started":
        return "Mulai";

      case "finished":
        return "Selesai";

      default:
        return "Belum Mulai";
    }
  };
  return (
    <Fragment>
      <PageTitle activeMenu="Table" motherMenu="Bootstrap" />
      <Row>
        <Col lg={12}>
          <Card>
            <Tab.Container defaultActiveKey={"Week"}>
              <div className="card-header border-0 pb-0 flex-wrap">
                <h4 className="heading mb-0">School Overview</h4>
                <Nav as="ul" className="nav nav-pills mix-chart-tab">
                  <Nav.Item as="li" className="nav-item">
                    <Nav.Link
                      active={query.includes("started")}
                      onClick={() => setQuery("status=started")}
                    >
                      Dimulai
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li" className="nav-item">
                    <Nav.Link
                      active={query.includes("created")}
                      onClick={() => setQuery("status=created")}
                    >
                      Belum dikerjakan
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li" className="nav-item">
                    <Nav.Link
                      active={query.includes("finished")}
                      onClick={() => setQuery("status=finished")}
                    >
                      Selesai
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
              <div className="card-body">
                <Tab.Content>
                  {isMobile ? (
                    <div className="d-flex flex-column gap-3">
                      {data.map((item, index) => (
                        <div
                          key={index}
                          className="border rounded shadow-sm p-3"
                        >
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="fw-bold text-primary">
                              {item.detail.nama}
                            </div>
                            <small className="text-muted">
                              #
                              {(currentPage - 1) * (isMobile ? 5 : 10) +
                                index +
                                1}
                            </small>
                          </div>

                          <div className="mb-2">
                            <i className="fa-solid fa-code me-2 text-secondary"></i>
                            <strong>Kode:</strong> {item.ujian.code}
                          </div>

                          <div className="mb-2">
                            <i className="fa-solid fa-calendar-days me-2 text-secondary"></i>
                            <strong>Tanggal:</strong> {item.ujian.started_at}
                          </div>

                          <div className="mb-2">
                            <i className="fa-solid fa-clock me-2 text-secondary"></i>
                            <strong>Durasi:</strong> {item.ujian.durasi / 60}{" "}
                            Menit
                          </div>

                          <div className="mb-2">
                            <i className="fa-solid fa-door-open me-2 text-secondary"></i>
                            <strong>Ruangan:</strong>{" "}
                            {item.ujian.detail.ruangan}
                          </div>

                          {item.status !== "finished" ? (
                            <>
                              <div className="text-end">
                                <button
                                  className="btn btn-primary btn-sm px-3"
                                  onClick={() => handleMulaiUjian(item.id)}
                                >
                                  <i className="fa-solid fa-play me-1"></i>{" "}
                                  Mulai
                                </button>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <Table responsive>
                      <thead>
                        <tr>
                          <th className="width80">
                            <strong>#</strong>
                          </th>
                          <th>
                            <strong>Kode Ujian</strong>
                          </th>
                          <th>
                            <strong>Nama Ujian</strong>
                          </th>
                          <th className="text-nowrap">
                            <strong>Tanggal Ujian</strong>
                          </th>
                          <th className="text-nowrap">
                            <strong>Durasi</strong>
                          </th>
                          <th>
                            <strong>Ruangan</strong>
                          </th>
                          {!query.includes("finished") ? (
                            <th className="text-center">
                              <strong>Aksi</strong>
                            </th>
                          ) : (
                            ""
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.ujian.code}</td>
                            <td>{item.detail.nama}</td>
                            <td className="text-nowrap">
                              {item.ujian.started_at}
                            </td>
                            <td className="text-nowrap">
                              {item.ujian.durasi / 60} Menit
                            </td>
                            <td>{item.ujian.detail.ruangan}</td>
                            {item.status !== "finished" ? (
                              <td className="text-center">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => handleMulaiUjian(item.id)}
                                >
                                  Mulai
                                </button>
                              </td>
                            ) : (
                              ""
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                  <Pagination
                    totalData={totalData}
                    dataPerPage={isMobile ? 5 : 10}
                    onChange={handlePaging}
                  />
                </Tab.Content>
              </div>
            </Tab.Container>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ListUjian;
